module.exports = __webpack_public_path__ + "assets/img/thumb-ARUMALABS-2-Video.8b2dac16.webp";